import React from "react";
import { Modal as MUIModal, Box } from "@mui/material";

export interface ModalProps {
  children: React.ReactNode;
  onClose: () => void;
}

const Modal: React.FC<ModalProps> = ({ children, onClose }) => {
  return (
    <MUIModal open onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: { xs: 2, sm: 4 },
          borderRadius: 2,
          // Without these the panel is sized purely by its children: anything
          // taller than the viewport is centred so its top half sits at
          // negative coordinates, with nothing to scroll it back into view.
          maxWidth: "calc(100vw - 32px)",
          maxHeight: "calc(100dvh - 32px)",
          overflowY: "auto",
        }}
      >
        {children}
      </Box>
    </MUIModal>
  );
};

export default Modal;
